import { render } from "./FooterBarPublic.vue?vue&type=template&id=7aac24e9&scoped=true"
import script from "./FooterBarPublic.vue?vue&type=script&lang=js"
export * from "./FooterBarPublic.vue?vue&type=script&lang=js"

import "./FooterBarPublic.vue?vue&type=style&index=0&id=7aac24e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aac24e9"]])

export default __exports__